module.exports = __webpack_public_path__ + "static/img/search.1717fea6.png";